export const EContractorPaymentStatus = {
  pending: "pending",
  "pre-processing": "pre-processing",
  "pre-processed": "pre-processed",
  processed: "processed",
  processing: "processing",
  voided: "voided",
  failed: "failed",
} as const;

export type EContractorPaymentStatus =
  (typeof EContractorPaymentStatus)[keyof typeof EContractorPaymentStatus];
